import { registerLocaleData } from '@angular/common';
import { DatePipe } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import localeDECH from '@angular/common/locales/de-CH';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { TRANSLOCO_SCOPE, TranslocoService } from '@jsverse/transloco';

registerLocaleData(localeDECH);

const defaultModules = [BrowserModule];

const internalModules = [
  AppRoutingModule,
];

const externalModules = [TranslocoRootModule];

@NgModule({
  declarations: [],
  imports: [defaultModules, internalModules, externalModules],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'de-CH' },
    // Scope cannot be null if defined => otherwise the translation will not work
    { provide: TRANSLOCO_SCOPE, useValue: ['pmtBootstrap', 'pmtDatepicker'] },
    provideHttpClient(withInterceptorsFromDi())
  ],
})
export class AppModule {
  constructor(translate: TranslocoService) {
    translate.setDefaultLang('de');
  }
}
